import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface ConfirmModalData {
	title?: string;
	message: string;
	yesBtnText?: string;
	noBtnText?: string;
}
@Component({
	selector: 'app-common-confirm-modal',
	templateUrl: './common-confirm-modal.component.html',
	styleUrls: ['./common-confirm-modal.component.css']
})
export class CommonConfirmModalComponent implements OnInit {

	public title: string;
	public message: string;
	public yesBtnText: string;
	public noBtnText: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ConfirmModalData,
		public dialogRef: MatDialogRef<CommonConfirmModalComponent>
	) { }

	ngOnInit() {
		this.title = this.data.title || 'Confirm';
		this.message = this.data.message;
		this.yesBtnText = this.data.yesBtnText || 'Yes';
		this.noBtnText = this.data.noBtnText || 'Cancel';
	}

}



// WEBPACK FOOTER //
// ./src/app/components/common-confirm-modal/common-confirm-modal.component.ts